import React from 'react';
import { RegisterInputContainer } from '../../../../../components/ui/InputSearch';
import { InputElement } from '../../../../../ui/Input/Input';
import { IRegisterForm } from '../../../../../interface/Auth/frontend';
import { useTranslation } from 'react-i18next';
import { useNameInput } from '../../../hooks/useNameInput';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
	isDisabled?: boolean;
}

export const RegFormLastName: React.FC<IProps> = ({ registerForm, setRegisterForm, isDisabled }) => {
	const { t } = useTranslation();

  const { handleChange, displayError } = useNameInput({
		citizenshipId: registerForm.citizenshipId,
		fieldName: 'surname',
		currentValue: registerForm.surname,
		onUpdate: (value) => setRegisterForm({ ...registerForm, surname: value })
	});

	return (
		<RegisterInputContainer style={{ marginTop: '16px' }}>
			<InputElement
				placeholder={t('passport.registrationForm.surnameForm.hint')}
				error={displayError}
				disabled={isDisabled}
				value={registerForm.surname}
				onChange={handleChange}
			/>
		</RegisterInputContainer>
	);
};
